import React from "react";
import { Box, Typography, Card, Chip } from "@mui/material";
import {
  TrainingSectionAttemptStatus,
  TrainingSectionAttemptStatusKey,
} from "../utils/enums";
import { useTheme } from "@mui/material/styles";

const TrainingMaterialCard = ({
  section,
  getIconByType,
  onClick,
  small = true,
  showCompletetionStaus = false,
  trainingSectionMap = {},
}) => {
  const theme = useTheme();
  return (
    <Card
      onClick={(event) => {
        // Check if onClick expects 2 parameters (event, section) or 1 parameter (section)
        if (onClick.length >= 2) {
          onClick(event, section);
        } else {
          onClick(section);
        }
      }}
      sx={{
        width: "100%",
        borderRadius: "8px",
        border: "1px solid",
        borderColor: theme.customColors.border.strong,
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
        transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
        "&:hover": {
          cursor: "pointer",
          boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
          border: "1px solid",
          borderColor: theme.customColors.border.disabled,
          transform: "translateY(-2px)",
          transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
        },
        "& .MuiSvgIcon-root": {
          transition: "transform 0.3s ease",
        },
        "&:hover .MuiSvgIcon-root": {
          transform: "scale(1.1)",
        },
        "& .MuiTypography-subtitle2": {
          transition: "color 0.3s ease",
        },
        "&:hover .MuiTypography-subtitle2": {
          color: theme.customColors.icons.primary,
        },
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "flex-start",
          m: "15px",
          borderRadius: "10px",
        }}
      >
        {getIconByType(section?.section_type_key, small)}
      </Box>

      <Box sx={{ mx: "15px", mb: small ? "10px" : "20px" }}>
        <Typography variant="subtitle2" fontWeight={600} noWrap>
          {section?.title}
        </Typography>
        <Typography variant="caption" color="text.secondary">
          {trainingSectionMap?.[section?.section_type_key]}
        </Typography>
        {showCompletetionStaus && (
          <Box mt={0.5}>
            <Chip
              label={
                section?.progress_status_key ===
                  TrainingSectionAttemptStatusKey.COMPLETED
                  ? TrainingSectionAttemptStatus.COMPLETED
                  : TrainingSectionAttemptStatus.PENDING
              }
              size="small"
              sx={{
                backgroundColor:
                  section?.progress_status_key ===
                    TrainingSectionAttemptStatusKey.COMPLETED
                    ? theme.customColors.status.completed.bg
                    : theme.customColors.status.pending.bg,
                color:
                  section?.progress_status_key ===
                    TrainingSectionAttemptStatusKey.COMPLETED
                    ? theme.palette.primary.light
                    : theme.customColors.status.pending.main,
                fontWeight: "500",
              }}
            />
          </Box>
        )}
      </Box>
    </Card>
  );
};

export default TrainingMaterialCard;
